import React, { useState } from "react";
import { DatePicker, LocalizationProvider, DateCalendar } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Box, Button, TextField, LinearProgress, Grid } from '@mui/material';
import DateInterval from './DateInterval';

const DateTimePickerCustom = ({ label, onChange, calendar, date, interval, startDate, endDate }) => {
  const Picker = ({ sx, label, onChange }) => <Box
    sx={{
      paddingRight: '20px',
    }}
  >
    <Grid container>
      <Grid item xs={12} md={6}>
        <DatePicker
          value={date}
          onChange={onChange}
          label={label}
        />
      </Grid>
    </Grid>
  </Box>;

  return (
    <Box display='flex' justifyContent='center'>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        {calendar ?
          <DateCalendar value={date} label={label} onChange={onChange} />
          : interval ?
            <DateInterval onChange={onChange} startDate={startDate} endDate={endDate}/>
            : <Picker label={label} onChange={onChange} />}
      </LocalizationProvider>
    </Box>
  );
}

export default DateTimePickerCustom;